import type { Transaction } from '@shared/transactions-types';
import { getFeatureConfig } from '@luna/feature-config';

import { isType } from '../predicates/isType';
import { hasSepaScheme } from '../predicates/hasSepaScheme';

export const showExecutionTime = (transaction: Transaction): boolean => {
    const { showExecutionTimeForTransactionTypes, showExecutionTimeForSepaSchemes } =
        getFeatureConfig((config) => config.transactions);

    return (
        isType(...showExecutionTimeForTransactionTypes)(transaction) ||
        hasSepaScheme(...showExecutionTimeForSepaSchemes)(transaction)
    );
};
